import variables from '@/library/mixins/variables';

const mixin = {
    ...variables,
};

export default mixin;
